import chinaModel from '../assets/themes/gold/images/model/china-model.png?url'
import usaModel from '../assets/themes/gold/images/model/usa-model.png?url'
import egyptModel from '../assets/themes/gold/images/model/egypt-model.png?url'
import germanyModel from '../assets/themes/gold/images/model/germany-model.png?url'
import indiaModel from '../assets/themes/gold/images/model/india-model.png?url'
import japanModel from '../assets/themes/gold/images/model/japan-model.png?url'
import koreaModel from '../assets/themes/gold/images/model/korea-model.png?url'
import laosModel from '../assets/themes/gold/images/model/laos-model.png?url'
import malaysiaModel from '../assets/themes/gold/images/model/malaysia-model.png?url'
import russiaModel from '../assets/themes/gold/images/model/russia-model.png?url'
import singaporeModel from '../assets/themes/gold/images/model/singapore-model.png?url'
import taiwanModel from '../assets/themes/gold/images/model/taiwan-model.png?url'
import thailandModel from '../assets/themes/gold/images/model/thailand-model.png?url'
import vietnamModel from '../assets/themes/gold/images/model/vietnam-model.png?url'
import hangsengModel from '../assets/themes/gold/images/model/hangseng-model.png?url'
import englandModel from '../assets/themes/gold/images/model/england-model.png?url'
import maltaModel from '../assets/themes/gold/images/model/malta-model.png?url'

// Loading Screen Assets
import loadingScreenBg1 from '../assets/themes/gold/images/loadingscreen/loading1_bg.jpg?url'
import loadingScreenBg2 from '../assets/themes/gold/images/loadingscreen/loading2_bg.jpg?url'
import loadingScreenBg3 from '../assets/themes/gold/images/loadingscreen/loading3_bg.jpg?url'

// SVG Assets
import error404Light from '../assets/themes/gold/images/svg/404/error_404_light.svg?url'
import error404Dark from '../assets/themes/gold/images/svg/404/error_404_dark.svg?url'
import noDataLight from '../assets/themes/gold/images/svg/NoDataAvailable/no_data_available_light.svg?url'
import noDataDark from '../assets/themes/gold/images/svg/NoDataAvailable/no_data_available_dark.svg?url'
import logoLight from '../assets/themes/gold/images/logo/logo_light.svg?url'
import logoDark from '../assets/themes/gold/images/logo/logo_dark.svg?url'

// Flag Assets - Small Flags
import thailandFlag from '../assets/themes/gold/images/flag/small-flag/thailand-flag.png?url'
import usaFlag from '../assets/themes/gold/images/flag/small-flag/usa-flag.png?url'
import mmFlag from '../assets/themes/gold/images/flag/small-flag/myanmar-flag.png?url'
import chinaFlag from '../assets/themes/gold/images/flag/small-flag/china-flag.png?url'
import egyptFlag from '../assets/themes/gold/images/flag/small-flag/egypt-flag.png?url'
import germanyFlag from '../assets/themes/gold/images/flag/small-flag/germany-flag.png?url'
import indiaFlag from '../assets/themes/gold/images/flag/small-flag/india-flag.png?url'
import japanFlag from '../assets/themes/gold/images/flag/small-flag/japan-flag.png?url'
import koreaFlag from '../assets/themes/gold/images/flag/small-flag/korea-flag.png?url'
import laosFlag from '../assets/themes/gold/images/flag/small-flag/laos-flag.png?url'
import malaysiaFlag from '../assets/themes/gold/images/flag/small-flag/malaysia-flag.png?url'
import russiaFlag from '../assets/themes/gold/images/flag/small-flag/russia-flag.png?url'
import singaporeFlag from '../assets/themes/gold/images/flag/small-flag/singapore-flag.png?url'
import taiwanFlag from '../assets/themes/gold/images/flag/small-flag/taiwan-flag.png?url'
import vietnamFlag from '../assets/themes/gold/images/flag/small-flag/vietnam-flag.png?url'
import hangsengFlag from '../assets/themes/gold/images/flag/small-flag/hangseng-flag.png?url'
import englandFlag from '../assets/themes/gold/images/flag/small-flag/england-flag.png?url'
import maltaFlag from '../assets/themes/gold/images/flag/small-flag/malta-flag.png?url'
import cambodiaFlag from '../assets/themes/gold/images/flag/small-flag/camboadia-flag.png?url'

// Flag Assets - Background Flags
import thailandFlagBg from '../assets/themes/gold/images/flag/background-flag/thailand-flag-bg.jpg?url'
import chinaFlagBg from '../assets/themes/gold/images/flag/background-flag/china-flag-bg.jpg?url'
import hangsengFlagBg from '../assets/themes/gold/images/flag/background-flag/hangseng-flag-bg.jpg?url'
import japanFlagBg from '../assets/themes/gold/images/flag/background-flag/japan-flag-bg.jpg?url'
import koreaFlagBg from '../assets/themes/gold/images/flag/background-flag/korea-flag-bg.jpg?url'
import laosFlagBg from '../assets/themes/gold/images/flag/background-flag/laos-flag-bg.jpg?url'
import malaysiaFlagBg from '../assets/themes/gold/images/flag/background-flag/malaysia-flag-bg.jpg?url'
import vietnamFlagBg from '../assets/themes/gold/images/flag/background-flag/vietnam-flag-bg.jpg?url'
import hanoiVipFlagBg from '../assets/themes/gold/images/flag/background-flag/hanoi-vip-flag-bg.jpg?url'
import hanoiSpecialFlagBg from '../assets/themes/gold/images/flag/background-flag/hanoi-special-flag-bg.jpg?url'
import singaporeFlagBg from '../assets/themes/gold/images/flag/background-flag/singapore-flag-bg.jpg?url'
import indiaFlagBg from '../assets/themes/gold/images/flag/background-flag/india-flag-bg.jpg?url'
import germanyFlagBg from '../assets/themes/gold/images/flag/background-flag/germany-flag-bg.jpg?url'
import russiaFlagBg from '../assets/themes/gold/images/flag/background-flag/russia-flag-bg.jpg?url'
import egyptFlagBg from '../assets/themes/gold/images/flag/background-flag/egypt-flag-bg.jpg?url'
import englandFlagBg from '../assets/themes/gold/images/flag/background-flag/england-flag-bg.jpg?url'
import usaFlagBg from '../assets/themes/gold/images/flag/background-flag/usa-flag-bg.jpg?url'
import taiwanFlagBg from '../assets/themes/gold/images/flag/background-flag/taiwan-flag-bg.jpg?url'
import maltaFlagBg from '../assets/themes/gold/images/flag/background-flag/malta-flag-bg.jpg?url'
import stockFlagBg from '../assets/themes/gold/images/flag/background-flag/stock-flag-bg.jpg?url'
import baacFlagBg from '../assets/themes/gold/images/flag/background-flag/baac-flag-bg.jpg?url'
import aomsinFlagBg from '../assets/themes/gold/images/flag/background-flag/aomsin-flag-bg.jpg?url'
import cryptoFlagBg from '../assets/themes/gold/images/flag/background-flag/crypto-flag-bg.jpg?url'
import yeekeeVipFlagBg from '../assets/themes/gold/images/flag/background-flag/yeekee-vip-flag-bg.jpg?url'
import yeekeeFlagBg from '../assets/themes/gold/images/flag/background-flag/yeekee-flag-bg.jpg?url'

// Flag Assets - Banner Flags
import aomsinBannerFlag from '../assets/themes/gold/images/flag/banner-flag/aomsin-banner-flag.jpg?url'
import chinaAfternoonStockBannerFlag from '../assets/themes/gold/images/flag/banner-flag/china-afternoon-stock-banner-flag.jpg?url'
import chinaMorningStockBannerFlag from '../assets/themes/gold/images/flag/banner-flag/china-morning-stock-banner-flag.jpg?url'
import dowjonesBannerFlag from '../assets/themes/gold/images/flag/banner-flag/dowjones-banner-flag.jpg?url'
import egyptBannerFlag from '../assets/themes/gold/images/flag/banner-flag/egypt-banner-flag.jpg?url'
import englandBannerFlag from '../assets/themes/gold/images/flag/banner-flag/england-banner-flag.jpg?url'
import germanyBannerFlag from '../assets/themes/gold/images/flag/banner-flag/germany-banner-flag.jpg?url'
import hangsengBannerFlag from '../assets/themes/gold/images/flag/banner-flag/hangseng-banner-flag.jpg?url'
import hangsengMorningStockBannerFlag from '../assets/themes/gold/images/flag/banner-flag/hangseng-morning-stock-banner-flag.jpg?url'
import hangsengAfternoonStockBannerFlag from '../assets/themes/gold/images/flag/banner-flag/hangseng-afternoon-stock-banner-flag.jpg?url'
import indiaBannerFlag from '../assets/themes/gold/images/flag/banner-flag/india-banner-flag.jpg?url'
import japanBannerFlag from '../assets/themes/gold/images/flag/banner-flag/japan-banner-flag.jpg?url'
import nikkeiMorningStockBannerFlag from '../assets/themes/gold/images/flag/banner-flag/nikkei-morning-stock-banner-flag.jpg?url'
import koreaBannerFlag from '../assets/themes/gold/images/flag/banner-flag/korea-banner-flag.jpg?url'
import laosBannerFlag from '../assets/themes/gold/images/flag/banner-flag/laos-banner-flag.jpg?url'
import malaysiaBannerFlag from '../assets/themes/gold/images/flag/banner-flag/malaysia-banner-flag.jpg?url'
import nikkeiAfternoonStockBannerFlag from '../assets/themes/gold/images/flag/banner-flag/nikkei-afternoon-stock-banner-flag.jpg?url'
import russiaBannerFlag from '../assets/themes/gold/images/flag/banner-flag/russia-banner-flag.jpg?url'
import singaporeBannerFlag from '../assets/themes/gold/images/flag/banner-flag/singapore-banner-flag.jpg?url'
import taiwanBannerFlag from '../assets/themes/gold/images/flag/banner-flag/taiwan-banner-flag.jpg?url'
import thaiAfternoonStockBannerFlag from '../assets/themes/gold/images/flag/banner-flag/thai-afternoon-stock-banner-flag.jpg?url'
import thaiGovernmentBankBannerFlag from '../assets/themes/gold/images/flag/banner-flag/thai-government-bank-banner-flag.jpg?url'
import thaiGovernmentBankSetBannerFlag from '../assets/themes/gold/images/flag/banner-flag/thai-government-bank-set-banner-flag.jpg?url'
import thaiGovernmentBannerFlag from '../assets/themes/gold/images/flag/banner-flag/thai-government-banner-flag.jpg?url'
import thaiGovernmentSetBannerFlag from '../assets/themes/gold/images/flag/banner-flag/thai-government-set-banner-flag.jpg?url'
import governmentSetLotteryBannerFlag from '../assets/themes/gold/images/flag/banner-flag/government-set-lottery-banner-flag.jpg?url'
import laosGroupSetBannerFlag from '../assets/themes/gold/images/flag/banner-flag/laos-group-set-banner-flag.jpg?url'
import thaiMorningStockBannerFlag from '../assets/themes/gold/images/flag/banner-flag/thai-morning-stock-banner-flag.jpg?url'
import usaBannerFlag from '../assets/themes/gold/images/flag/banner-flag/usa-banner-flag.jpg?url'
import vietnamBannerFlag from '../assets/themes/gold/images/flag/banner-flag/vietnam-banner-flag.jpg?url'
import yeekeeBannerFlag from '../assets/themes/gold/images/flag/banner-flag/yeekee-banner-flag.jpg?url'
import yeekeeMaltaBannerFlag from '../assets/themes/gold/images/flag/banner-flag/yeekee-malta-banner-flag.jpg?url'
import baacBannerFlag from '../assets/themes/gold/images/flag/banner-flag/baac-banner-flag.jpg?url'
import stockBannerFlag from '../assets/themes/gold/images/flag/banner-flag/stock-banner-flag.jpg?url'
import yeekeeVipBannerFlag from '../assets/themes/gold/images/flag/banner-flag/yeekee-vip-banner-flag.jpg?url'
import cryptoBannerFlag from '../assets/themes/gold/images/flag/banner-flag/crypto-banner-flag.jpg?url'
import governmentSavingsBankBannerFlag from '../assets/themes/gold/images/flag/banner-flag/government-savings-bank-banner-flag.jpg?url'
import hanoiBannerFlag from '../assets/themes/gold/images/flag/banner-flag/hanoi-banner-flag.jpg?url'
import hanoiVipBannerFlag from '../assets/themes/gold/images/flag/banner-flag/hanoi-vip-banner-flag.jpg?url'
import hanoiSpecialBannerFlag from '../assets/themes/gold/images/flag/banner-flag/hanoi-special-banner-flag.jpg?url'
import laostarBannerFlag from '../assets/themes/gold/images/flag/banner-flag/laostar-banner-flag.jpg?url'
import laoStarStockBannerFlag from '../assets/themes/gold/images/flag/banner-flag/lao-star-stock-banner-flag.jpg?url'
import malaysiaStockBannerFlag from '../assets/themes/gold/images/flag/banner-flag/malaysia-stock-banner-flag.jpg?url'
import thaiStockEveningBannerFlag from '../assets/themes/gold/images/flag/banner-flag/thai-stock-evening-banner-flag.jpg?url'
import thaiStockPmBannerFlag from '../assets/themes/gold/images/flag/banner-flag/thai-stock-pm-banner-flag.jpg?url'

export const modelImageUrls: Record<string, string> = {
  china: chinaModel,
  usa: usaModel,
  egypt: egyptModel,
  germany: germanyModel,
  india: indiaModel,
  japan: japanModel,
  korea: koreaModel,
  laos: laosModel,
  malaysia: malaysiaModel,
  russia: russiaModel,
  singapore: singaporeModel,
  taiwan: taiwanModel,
  thailand: thailandModel,
  vietnam: vietnamModel,
  hangseng: hangsengModel,
  england: englandModel,
  malta: maltaModel,
}

export const LOADING_ASSETS = {
  background: loadingScreenBg1, // Default fallback
  backgrounds: {
    bg1: loadingScreenBg1,
    bg2: loadingScreenBg2,
    bg3: loadingScreenBg3,
  },
} as const

export type LoadingBackgroundType = 'bg1' | 'bg2' | 'bg3'

export const SVG_ASSETS = {
  ERROR_404: {
    light: error404Light,
    dark: error404Dark,
  },
  NO_DATA: {
    light: noDataLight,
    dark: noDataDark,
  },
  LOGO: {
    light: logoLight,
    dark: logoDark,
  },
} as const

// Small Flag Assets
export const smallFlagImageUrls: Record<string, string> = {
  china: chinaFlag,
  egypt: egyptFlag,
  germany: germanyFlag,
  india: indiaFlag,
  japan: japanFlag,
  korea: koreaFlag,
  laos: laosFlag,
  malaysia: malaysiaFlag,
  russia: russiaFlag,
  singapore: singaporeFlag,
  taiwan: taiwanFlag,
  thailand: thailandFlag,
  usa: usaFlag,
  vietnam: vietnamFlag,
  hangseng: hangsengFlag,
  england: englandFlag,
  malta: maltaFlag,
  mm: mmFlag,
  cambodia: cambodiaFlag,
  th: thailandFlag,
  en: usaFlag,
}

// Background Flag Assets
export const backgroundFlagImageUrls: Record<string, string> = {
  thailand: thailandFlagBg,
  china: chinaFlagBg,
  hangseng: hangsengFlagBg,
  japan: japanFlagBg,
  korea: koreaFlagBg,
  laos: laosFlagBg,
  malaysia: malaysiaFlagBg,
  vietnam: vietnamFlagBg,
  'hanoi-vip': hanoiVipFlagBg,
  'hanoi-special': hanoiSpecialFlagBg,
  singapore: singaporeFlagBg,
  india: indiaFlagBg,
  germany: germanyFlagBg,
  russia: russiaFlagBg,
  egypt: egyptFlagBg,
  england: englandFlagBg,
  usa: usaFlagBg,
  taiwan: taiwanFlagBg,
  malta: maltaFlagBg,
  stock: stockFlagBg,
  baac: baacFlagBg,
  aomsin: aomsinFlagBg,
  crypto: cryptoFlagBg,
  'yeekee-vip': yeekeeVipFlagBg,
  yeekee: yeekeeFlagBg,
  gsb: aomsinFlagBg, // Same as aomsin
}

// Banner Flag Assets
export const bannerFlagImageUrls: Record<string, string> = {
  'aomsin-lotto': aomsinBannerFlag,
  'china-afternoon-stock': chinaAfternoonStockBannerFlag,
  'china-morning-stock': chinaMorningStockBannerFlag,
  'dowjones-stock': dowjonesBannerFlag,
  'egypt-stock': egyptBannerFlag,
  'england-stock': englandBannerFlag,
  'german-stock': germanyBannerFlag,
  hangseng: hangsengBannerFlag,
  'hangseng-morning-stock': hangsengMorningStockBannerFlag,
  'hangseng-afternoon-stock': hangsengAfternoonStockBannerFlag,
  'india-lotto': indiaBannerFlag,
  'japan-lotto': japanBannerFlag,
  'nikkei-morning-stock': nikkeiMorningStockBannerFlag,
  'korea-stock': koreaBannerFlag,
  'laos-lotto': laosBannerFlag,
  'malaysia-lotto': malaysiaBannerFlag,
  'nikkei-afternoon-stock': nikkeiAfternoonStockBannerFlag,
  'russia-stock': russiaBannerFlag,
  'singapore-stock': singaporeBannerFlag,
  'taiwan-stock': taiwanBannerFlag,
  'thai-afternoon-stock': thaiAfternoonStockBannerFlag,
  'thai-government-bank': thaiGovernmentBankBannerFlag,
  'thai-government-bank-set': thaiGovernmentBankSetBannerFlag,
  'thai-government': thaiGovernmentBannerFlag,
  'thai-government-set': thaiGovernmentSetBannerFlag,
  'government-set-lottery': governmentSetLotteryBannerFlag,
  'laos-group-set': laosGroupSetBannerFlag,
  // Additional mappings for different naming conventions
  'thai-government-bank-lotto': thaiGovernmentBankBannerFlag,
  'thai-government-bank-lotto-set': thaiGovernmentBankSetBannerFlag,
  'thai-government-lotto': thaiGovernmentBannerFlag,
  'thai-government-lotto-set': thaiGovernmentSetBannerFlag,
  'laos-group-set-banner-flag': laosGroupSetBannerFlag,
  'thai-morning-stock': thaiMorningStockBannerFlag,
  'usa-stock': usaBannerFlag,
  'vietnam-lotto': vietnamBannerFlag,
  yeekee: yeekeeBannerFlag,
  'yeekee-malta': yeekeeMaltaBannerFlag,
  'baac-lotto': baacBannerFlag,
  stock: stockBannerFlag,
  'yeekee-vip': yeekeeVipBannerFlag,
  crypto: cryptoBannerFlag,
  'government-savings-bank': governmentSavingsBankBannerFlag,
  hanoi: hanoiBannerFlag,
  'hanoi-vip': hanoiVipBannerFlag,
  'hanoi-special': hanoiSpecialBannerFlag,
  laostar: laostarBannerFlag,
  'lao-star-stock': laoStarStockBannerFlag,
  'malaysia-stock': malaysiaStockBannerFlag,
  'thai-stock-evening': thaiStockEveningBannerFlag,
  'thai-stock-pm': thaiStockPmBannerFlag,
}

// Legacy flag assets for backward compatibility
export const FLAG_ASSETS = {
  th: thailandFlag,
  en: usaFlag,
  mm: mmFlag,
  km: cambodiaFlag,
} as const
